/* AffiliateDisclosure — FTC-compliant disclosure line used anywhere
   Faitharama earns commission from a partner product.

   Per FTC 16 CFR Part 255 (Endorsement Guides), affiliate relationships
   must be disclosed in a way that's clear, conspicuous, and BEFORE the
   click. This component renders that line consistently across the site. */
import { Info } from "lucide-react";

export default function AffiliateDisclosure({ compact = false }) {
  if (compact) {
    return (
      <p
        data-testid="affiliate-disclosure-compact"
        className="text-[11px] italic leading-snug mt-2"
        style={{ color: "#0F172A", opacity: 0.7 }}
      >
        Affiliate disclosure: Faitharama.com earns a commission when you buy
        through these links. You pay no extra.
      </p>
    );
  }
  return (
    <div
      data-testid="affiliate-disclosure"
      className="mx-auto max-w-3xl rounded-lg px-4 py-3 flex items-start gap-3 mt-6"
      style={{ background: "#E0F2FE", border: "1.5px solid #BAE6FD" }}
    >
      <Info
        className="w-4 h-4 flex-shrink-0 mt-0.5"
        style={{ color: "#0F172A" }}
        aria-hidden="true"
      />
      <p
        className="text-xs md:text-sm leading-relaxed"
        style={{ color: "#0F172A" }}
      >
        <strong>Affiliate disclosure.</strong> Faitharama.com earns a commission
        when you purchase products from our partner brands (GoGreen Hemp,
        Bee&amp;You, Goli, Piurify and others) through links on this page.
        It costs you nothing extra. Faitharama only promotes what the partner
        brand says on its own product page — we do not make additional claims.
      </p>
    </div>
  );
}
